export const shippingModeReducer = (state = "DHL", action) => {
  switch (action.type) {
    case "SET_SHIPPING_MODE":
      return action.payload;
    default:
      return state;
  }
};